import { render, staticRenderFns } from "./drawer-house-info.vue?vue&type=template&id=2dfaf028&scoped=true&"
import script from "./drawer-house-info.vue?vue&type=script&lang=js&"
export * from "./drawer-house-info.vue?vue&type=script&lang=js&"
import style0 from "./drawer-house-info.vue?vue&type=style&index=0&id=2dfaf028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfaf028",
  null
  
)

export default component.exports